import { useMemo, useState } from 'react'
import { connect, useSelector } from 'react-redux'

import DataTable from '../../containers/DataTable'

import landerAPICall from '../../app/apiCalls/landerAPICall'
import { prelanders_list } from '../../app/apiEndpoints'

const PreLanderTable = (props) => {
    const [data, setData] = useState([])

    const tableID = "banner"
    const tableFields = ["ID", "Name", "URL", "Active", "Reg Count", ""]

    const userID = useSelector((state) => state.user.id)
    const companyID = useSelector((state) => state.user.company.id)
    const rowID = useSelector((state) => state.currentBannerID)
    const isSysadmin = useSelector((state) => state.user.isSysadmin)

    useMemo(() => {
        const getData = async () => {
            const data = await landerAPICall(prelanders_list, {'requester': userID, 'company': companyID })
            setData(data.landers)
        }
        getData()
    }, [userID, companyID])

    const tableData = () => {
        if(data.length === 0) {
            return [];
        } 
        let rows = [];
        data.forEach(row => {
            rows.push({'id': row.banner_id, 'values': [
                row.lpid,
                (props.showDetailsOnClick ? row.lander : `<a href="/landers/${row.lpid}">${row.lander}</a>`),
                `<a href="https://${row.host_domain}/pre/${row.lpid}/" target="_blank">https://${row.host_domain}/pre/${row.lpid}/</a>`,
                row.isactive,
                row.reg_count,
                `<a href="/landers/view/${row.lpid}/" class="btn btn-primary btn-sm">View</a> ${isSysadmin ? `<a href="/landers/${row.lpid}/" class="btn btn-primary btn-sm">Edit</a>` : ''}`
            ]});
        });
        return rows
    }

    return (
        <>
        <DataTable hover={true} tableID={tableID} fieldNames={tableFields} dataRows={tableData()} currentRowID={rowID} />
        </>
    )
}


export default connect(state => ({...state}))(PreLanderTable)